// Angular
import { Component, OnInit, Input } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslationService } from '../../../../../core/_base/layout';
import { I18n } from 'src/app/components/datepickeri18n/customDatePIckerI18n';
import { LanguageFlag } from 'src/app/core/_base/layout/models/languageFlag';
import { CountryContextService } from 'src/app/core/_base/layout/services/countryContext.service';

@Component({
    selector: 'kt-language-selector',
    templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit {
    @Input() iconType: '' | 'brand';

    constructor(
        private translationService: TranslationService,
        private router: Router,
        private i18n: I18n,
        private countryContextService: CountryContextService
    ) {}

    get languageSelected(): LanguageFlag {
        return this.countryContextService.languageSelected;
    }
    get languages(): LanguageFlag[] {
        return this.countryContextService.languages;
    }
    ngOnInit() {
        this.setSelectedLanguage();
        this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((event) => {
            this.setSelectedLanguage();
        });
    }

    private setActiveLanguage(lang: string) {
        this.countryContextService.languages.forEach((language: LanguageFlag) => {
            if (language.lang === lang) {
                language.active = true;
                this.countryContextService.languageSelected = language;
            } else {
                language.active = false;
            }
        });
    }

    setLanguage(lang: string): void {
        this.setActiveLanguage(lang);
        this.i18n.language = lang;
        this.translationService.setLanguage(lang);
    }

    setSelectedLanguage(): any {
        this.setLanguage(this.translationService.getSelectedLanguage());
    }
}
